__turbopack_context__.v({
  "desc": "Default-module__0HmEYW__desc",
  "error": "Default-module__0HmEYW__error",
  "hasDesc": "Default-module__0HmEYW__hasDesc",
  "hasSwitch": "Default-module__0HmEYW__hasSwitch",
  "isDisabled": "Default-module__0HmEYW__isDisabled",
  "wrapper": "Default-module__0HmEYW__wrapper",
});
